import { StyledItem, StyledRoot } from "./ToggleButton.styled"

interface MenuItem<T> {
  value: T
  title: string
}

interface Props<T> {
  items: MenuItem<T>[]
  activeItemValue: T
  onValueChange: (value: T) => void
}

function ToggleButton<T extends string = string>({ items, activeItemValue, onValueChange }: Props<T>) {
  return (
    <StyledRoot type="single" orientation="horizontal" value={activeItemValue as string} onValueChange={onValueChange}>
      {items.map((item) => {
        const isActive = activeItemValue === item.value
        return (
          <StyledItem key={item.value} active={isActive} value={item.value}>
            {item.title}
          </StyledItem>
        )
      })}
    </StyledRoot>
  )
}

export default ToggleButton
